import React, { Fragment } from 'react'

import { Heading } from '@offerzen/pinata'

import styles from './styles'

const SkillsHeading = () => (
  <Fragment>
    <Heading className={styles.heading}>What are your top technical skills?</Heading>

    <p className={styles.text}>
      Highlight the languages, frameworks, databases, tools, and methodologies you are most proficient in and would like to apply in your
      next job.
    </p>
    <p className={styles.text}>You can add up to 10 skills.</p>
  </Fragment>
)

export default SkillsHeading
